import React from 'react';
import ReactDOM from 'react-dom';
// import {App} from './App';
import {AppContainer} from './AppContainer';
import 'semantic-ui-css/semantic.min.css';
import {gdSdk} from './gd-sdk';


/* ReactDOM.render(
    <App></App>
,document.querySelector('#root')); */

(async ()=>{
    
    try{

        await gdSdk.load();        

    }catch(e){
        console.log('error loading gd sdk',e);
    }    

    ReactDOM.render(
        <AppContainer></AppContainer>
    ,document.querySelector('#root'));

})();
